<div *ngIf="loading">
  <deltacapita-content-loader></deltacapita-content-loader>
</div>
<div *ngIf="!loading">
  <form [formGroup]="createDistributorContactForm" (ngSubmit)="createDistributorContact()">
    <div class="form-group icon">
      <app-dc-select
        label="Distributor"
        [labelId]="'distributor'"
        [placeholder]="'Select distributor'"
        [items]="distributorsDropdownData"
        [checkbox]="false"
        formControlName="clientid"
        [disabled]="false"
        [multiple]="false"
        [searchable]="true"
        [closeOnSelect]="true"
        [readonly]="isDistributorSet"
      ></app-dc-select>
    </div>

    <div class="form-group icon">
      <app-dc-input formControlName="name" type="text" label="Name" placeholder="Name"></app-dc-input>
    </div>

    <div class="form-group icon">
      <app-dc-input
        formControlName="email"
        type="email"
        label="Email"
        [id]="'Email'"
        placeholder="Email"
      ></app-dc-input>
    </div>

    <div class="form-group icon">
      <app-dc-input
        formControlName="tel"
        type="text"
        [id]="'tel'"
        label="Telephone (optional)"
        placeholder="Telephone (optional)"
      ></app-dc-input>
    </div>

    <div class="form-group icon">
      <app-dc-input
        formControlName="mobile"
        type="text"
        [id]="'mobile'"
        label="Mobile (optional)"
        placeholder="Mobile (optional)"
      ></app-dc-input>
    </div>

    <label>Region</label>
    <div class="row">
      <div class="col-4 d-flex align-items-center justify-content-center">
        <label>
          <input type="radio" name="template" id="emeaRadio" value="EMEA" checked formControlName="region" />
          <div class="front-end box">
            <span>EMEA</span>
          </div>
        </label>
      </div>
      <div class="col-4 d-flex align-items-center justify-content-center">
        <label>
          <input type="radio" name="template" id="amerRadio" value="AMER" formControlName="region" />
          <div class="back-end box">
            <span>AMER</span>
          </div>
        </label>
      </div>
      <div class="col-4 d-flex align-items-center justify-content-center">
        <label>
          <input type="radio" name="template" id="apacRadio" value="APAC" formControlName="region" />
          <div class="back-end box">
            <span>APAC</span>
          </div>
        </label>
      </div>
    </div>
    <br />
    <div class="m-3 d-flex align-items-center justify-content-center">
      <button class="btn btn-primary" type="submit" [disabled]="!createDistributorContactForm.valid">
        Create Contact
      </button>
    </div>
  </form>
</div>
